export default __webpack_public_path__ + "38b46f3616aec75ec792f242a1936cb7.png";